import _ from 'lodash';
import React from 'react';

import {connect} from 'react-redux';

import Button from 'components/Button';
import TreeSelect from 'components/Filters/TreeSelect';
import SelectFilter from 'components/Filters/SelectFilter';
import TccwFloorFilter from 'components/Filters/TccwFloorFilter';
import AllocationTypeFilter from 'components/Filters/AllocationTypeFilter';
import RoomPurposeTypeWithDateRangeFilter from 'components/Filters/RoomPurposeTypeWithDateRangeFilter';
import ToggleFilter from 'components/Filters/ToggleFilter';

import {
  exportXlsx,
  exportXlsxInBackground,
  selectXlsxExporting
} from 'ducks/files';
import {requiresMultiplePermissions, PERMISSIONS} from 'ducks/auth';

import {exportRoomAllocations as exportRoomAllocationsSdk} from 'sdk/allocations';

import './styles.css';

const ROOM_ALLOCATIONS_EXPORT_FILENAME = 'room_allocations';

interface PurposesFiltersProps {
  locationRef: string;
  roomTypeFilters: Array<any>;
  filters: any;
  rooms: Array<any>;
  floors: Array<any>;
  exportXlsxInBackground: any;
  requiresMultiplePermissions: any;
  setFilter: (field: string, value: any, withoutFetching?: boolean) => void;
  clearFilters: () => void;
}

class PurposesFilters extends React.Component<PurposesFiltersProps> {
  clearFilters = () => {
    this.props.clearFilters();
  };

  exportRoomAllocationsXlsx = () => {
    const {locationRef, filters} = this.props;

    const exportData = {
      locationRef,
      filters
    };

    this.props.requiresMultiplePermissions(
      {
        permissions: [
          {
            locationRef,
            permission: PERMISSIONS.VIEW_ROOM_PURPOSES
          },
          {
            permission: PERMISSIONS.VIEW_EXCEL_EXPORT_FILE
          }
        ]
      },
      () =>
        this.props.exportXlsxInBackground({
          exportData,
          exportSdk: exportRoomAllocationsSdk,
          fileName: ROOM_ALLOCATIONS_EXPORT_FILENAME
        })
    );
  };

  render() {
    const {rooms, roomTypeFilters, floors, filters, locationRef} = this.props;

    const roomTypeData = roomTypeFilters.map(roomTypeGroup => ({
      label: roomTypeGroup.name,
      data: roomTypeGroup.roomTypes.map(roomType => ({
        label: roomType.name,
        key: roomType.ref
      }))
    }));
    const roomsOptions = rooms.map(room => ({
      label: room.roomNumber,
      value: room.roomId
    }));

    const floorOptions = floors.map(floor => ({label: floor, value: floor}));

    return (
      <div className="AllocationsFilters colab-row-space-between colab-sidepadding-2">
        <div>
          <TreeSelect
            label="Room Type"
            data={roomTypeData}
            value={filters.roomTypes}
            onFilterChange={value =>
              this.props.setFilter('roomTypes', value.filter(x => x !== ''))
            }
          />
          <SelectFilter
            label="Room"
            data={roomsOptions}
            value={filters.rooms}
            onChange={value =>
              this.props.setFilter('rooms', value.filter(x => x !== ''))
            }
          />
          {locationRef !== 'tccw' && (
            <SelectFilter
              label="Floor"
              data={floorOptions}
              value={filters.floors.join(',')}
              onChange={value =>
                this.props.setFilter('floors', value.filter(x => x !== ''))
              }
            />
          )}
          {locationRef === 'tccw' && (
            <TccwFloorFilter
              onChange={value =>
                this.props.setFilter('floors', value.filter(x => x !== ''))
              }
              filters={filters}
              floors={floors}
            />
          )}
          <RoomPurposeTypeWithDateRangeFilter
            roomPurposeTypes={filters.roomPurposeTypes}
            purposeStartDate={filters.purposeStartDate}
            purposeEndDate={filters.purposeEndDate}
            setFilter={this.props.setFilter}
          />
          <AllocationTypeFilter
            value={filters.dummy}
            onChange={value => this.props.setFilter('dummy', value)}
          />
          <ToggleFilter
            label="Archived Rooms"
            value={filters.archived}
            onChange={() => this.props.setFilter('archived', !filters.archived)}
          />
        </div>
        <div>
          <Button
            white
            className="exportButton"
            onClick={this.exportRoomAllocationsXlsx}>
            Export Room Allocations
          </Button>
          <Button clear onClick={this.clearFilters}>
            Clear all filters
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isExporting: selectXlsxExporting(state, ROOM_ALLOCATIONS_EXPORT_FILENAME)
});

const mapDispatchToProps = {
  exportXlsxInBackground,
  exportXlsx,
  requiresMultiplePermissions
};

export default connect(mapStateToProps, mapDispatchToProps)(PurposesFilters);
